import React from 'react'
import { Component } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { ApplicationPaths, QueryParameterNames } from './ApiAuthorizationConstants'
import authService from './AuthorizeService'

export default class AuthorizeRoute extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ready: false,
            authenticated: false,
            requireRole: props.requireRole,
            role: ''
        };
    }

    componentDidMount() {
        this._subscription = authService.subscribe(() => this.authenticationChanged());
        this.populateAuthenticationState();
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
    }

    render() {
        const { ready, authenticated, role } = this.state;
        var link = document.createElement("a");
        link.href = this.props.path;
        const returnUrl = `${link.protocol}//${link.host}${link.pathname}${link.search}${link.hash}`;
        const loginRedirectUrl = `${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURIComponent(returnUrl)}`
        const logoutRedirectUrl = { pathname: `${ApplicationPaths.LogOut}`, state: { local: true } }
        if (!ready) {
            return <div></div>;
        } else {
            const { component: Component, ...rest } = this.props;
            return <Route {...rest}
                render={(props) => {
                    if (authenticated) {
                        if (!this.state.requireRole || this.state.requireRole.includes(this.state.role)) {
                            const toPass = { role, ...props }

                            return <Component {...toPass} />
                        } else {
                            if (this.state.role == 'Admin') {
                                return <Redirect to={'/admin'} />
                            } else {
                                return <Redirect to={'/'} />
                            }
                        }
                    } else {
                        return <Redirect to={loginRedirectUrl} />
                    }
                }} />
        }
    }

    async populateAuthenticationState() {
        const user = await authService.getUser();
        this.setState({ ready: true, authenticated: !!user, role: user?.role ?? '' });
    }

    async authenticationChanged() {
        this.setState({ ready: false, authenticated: false, role: '' });
        await this.populateAuthenticationState();
    }
}
